import React, { useState, useEffect } from "react";
import InputMask from "react-input-mask";
import { withRouter } from "react-router";
import { validarCNPJ } from "./../../utils/helper";

//Hooks
import { useInput, useCheckbox } from "./../../hooks/form";

//Components
import Buttom from "../../components/Buttom";
import LayoutSteps from "../Shared/LayoutSteps";
import Title from "../../components/Title";
import PhoneInput from "./../../components/PhoneInput";
import ErrorBox from "./../../components/ErrorBox";

//style
import "./style.scss";

//config
import config from "./../../utils/const";

const Juridica = props => {
  //state
  const [msg, setMsg] = useState([]);
  const [submitted, setSubmited] = useState(false);
  const { value: razaoSocial, bind: bindRazaoSocial, reset: resetRazaoSocial } = useInput("");
  const { value: contact, bind: bindContact, reset: resetContact } = useInput("");
  const { value: cnpj, bind: bindCnpj, reset: resetCnpj } = useInput("");
  const { value: phone, bind: bindphone, reset: resetphone } = useInput("");
  const { value: email, bind: bindemail, reset: resetemail } = useInput("");
  const { value: CbAgree, bind: bindCbAgree, reset: resetCbAgree } = useCheckbox(false);

  //Effects
  useEffect(() => {
    props.actions.setProgressConfig(true, "80%", "4/5", "60%");
  }, [props.actions]);

  useEffect(() => {
    if (msg.length === 0 && submitted) {
      props.history.push(`${config.url}educacao/payment`);
    }
  }, [props.history, msg, submitted]);

  //fn
  const submitForm = e => {
    e.preventDefault();

    //validate
    setMsg([]);
    setSubmited(true);
    validateField("txtRazaoSocial", razaoSocial);
    validateField("txtCnpj", cnpj);
    validateField("txtPhone", phone);
    validateField("txtEmail", email);
    validateField("cbAgree", CbAgree);

    props.actions.setDonate("razaoSocial", razaoSocial);
    props.actions.setDonate("contactPerson", contact);
    props.actions.setDonate("cnpj", cnpj);
    props.actions.setDonate("phone", phone);
    props.actions.setDonate("email", email);
  };

  const validateField = (fieldname, value) => {
    switch (fieldname) {
      case "txtRazaoSocial":
        if (value === null || value.trim().length === 0) addMsg("Preencha o campo Razão Social");
        break;
      case "txtCnpj":
        if (value === null || value.trim().length === 0) {
          addMsg("Preencha o campo CNPJ");
        } else if (!validarCNPJ(value)) {
          addMsg("CNPJ Inválido");
        }
        break;
      case "txtPhone":
        if (value === null || value.trim().length === 0) addMsg("Preencha o campo Telefone");
        break;
      case "txtEmail":
        if (value === null || value.trim().length === 0) {
          addMsg("Preencha o campo E-mail");
        } else if (!/\S+@\S+\.\S+/.test(value)) {
          addMsg("E-mail inválido");
        }
        break;
      case "cbAgree":
        if (!CbAgree) addMsg("Aceite os termos");
        break;
      default:
        break;
    }
  };

  const addMsg = val => {
    setMsg(msg => msg.concat(val));
  };

  return (
    <LayoutSteps
      className="wrapper-educacao-pf"
      renderButtom={() => (
        <Buttom
          data-class="btn-donation--default"
          text="continuar"
          to={`${config.url}educacao/payment`}
          onClick={e => {
            submitForm(e);
          }}
          {...props}
        />
      )}
    >
      <div className="container text-left">
        <Title>
          Ótimo! <br />
          Precisamos de mais alguns dados.
        </Title>
        <div class="form-group">
          <div className="row">
            <div className="col-sm-12 col-md-6">
              <label htmlFor="txtRazaoSocial">*Razão Social</label>
              <input type="text" className="form-control" id="txtRazaoSocial" name="txtRazaoSocial" {...bindRazaoSocial} />
            </div>
            <div className="col-sm-12 col-md-6">
              <label htmlFor="txtContact">Contato na empresa</label>
              <input type="text" className="form-control" id="txtContact" name="txtContact" {...bindContact} />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 col-md-6">
              <label htmlFor="txtCnpj">*CNPJ</label>
              <InputMask type="text" className="form-control" mask="99.999.999/9999-99" maskChar="" id="txtCnpj" name="txtCnpj" {...bindCnpj} />
            </div>
            <div className="col-sm-12 col-md-6">
              <label htmlFor="txtPhone">*Telefone</label>
              <PhoneInput type="text" className="form-control" id="txtPhone" name="txtPhone" {...bindphone} />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <label htmlFor="txtEmail">*E-mail</label>
              <input type="text" className="form-control" id="txtEmail" name="txtEmail" {...bindemail} />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" value="" id="cbAgree" name="cbAgree" {...bindCbAgree} />
                <label class="form-check-label" htmlFor="cbAgree">
                  Li e concordo com &nbsp;
                  <a href="#" target="_blank">
                    Termo de Adesão
                  </a>
                  &nbsp;e&nbsp;
                  <a href="#" target="_blank">
                    Políticas de privacidade
                  </a>
                </label>
              </div>
            </div>
          </div>
        </div>
        {msg && msg.length > 0 && <ErrorBox msg={msg} />}
      </div>
    </LayoutSteps>
  );
};

export default withRouter(Juridica);
